import {twJoin} from "tailwind-merge";

/* Direct port of growthjockey--website/app/components/atoms/ctaButtonFilled.tsx */
export function CtaButtonFilled({
    className,
    text,
    href,
    arrow,
    target,
    onClick,
}: {
    className?: string;
    text: string;
    href?: string;
    arrow?: boolean;
    target?: string;
    onClick?: (e?: React.MouseEvent<HTMLAnchorElement>) => void;
}) {
    return (
        <a
            target={target}
            href={href}
            aria-label={text}
            className={twJoin(
                "relative cursor-pointer grid grid-rows-1 grid-flow-col items-center px-2 py-1 lg:px-3 lg:py-2 gap-2 lg:gap-3 group no-underline",
                className,
            )}
            onClick={(e) => onClick?.(e)}
        >
            <div className="absolute inset-0 rounded-sm lg:rounded-lg bg-[#1F40CB] opacity-100 transition-opacity duration-200 group-hover:opacity-0" />
            <div className="absolute inset-0 rounded-sm lg:rounded-lg cta-bg-gradient opacity-0 transition-opacity duration-200 group-hover:opacity-100" />

            <div className="grid grid-flow-col grid-rows-1 place-items-center mx-auto lg:gap-sm gap-1 z-1 relative">
                <div className="text-nav-text-b text-[#FFFFFF]">{text}</div>
                {arrow === true && (
                    <div className="grid items-center">
                        <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M7.52867 11.5293L8.47133 12.472L12.9427 8.00063L8.47133 3.5293L7.52867 4.47196L10.3907 7.33396H4V8.6673H10.3907L7.52867 11.5293Z"
                                fill="white"
                            />
                        </svg>
                    </div>
                )}
            </div>
        </a>
    );
}
